// extracted by mini-css-extract-plugin
export default {"eventCategoryPill":"CategoryHelper_eventCategoryPill__4FEyf"};